






























import { PagePathToSubscribePaidMembership } from '@/models/paid-membership/subscribe/page-path'
import { URL } from '@/util/url'
import TitleSection from '@spa/components/atoms/TitleSection.vue'
import { PluginMixin } from '@spa/mixins/plugin'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'
@Component({
  components: { TitleSection },
})
export default class CompleteSubscribe extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  readonly title: string

  redirect() {
    const nextPath = PagePathToSubscribePaidMembership.parseStringified(location.href).pathAfterApply

    /**
     * MPAとSPA両方のパスを扱うため、vue-routerは使えない
     * 外部サイトへのリダイレクトを防ぐため、リダイレクトURLを現在のドメイン内に限定する
     */
    location.href = URL.createUrlForCurrentOrigin(nextPath)
  }
}
